var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { DndContext } from '@dnd-kit/core';
import { useDispatch, useSelector } from 'react-redux';
import resources from 'app/store/resources';
import { deleteDashboard, updateDashboard } from 'app/store/reducers/dashboards';
import { createWidget, deleteWidget } from 'app/store/reducers/widgets';
import { dashboardsSelector, selectedDashboardSelector } from 'app/store/selectors/dashboards';
import { widgetsByDashboardSelector } from 'app/store/selectors/widgets';
import { confirmDelete } from 'app/components/Modal/confirmDelete.jsx';
import { openModal } from 'app/components/Modal/openModal';
import ModalEditDashboard from 'app/pages/Project/Settings/Dashboards/ModalEditDashboard/ModalEditDashboard';
import ModalEditWidget from 'app/pages/Project/Settings/Dashboards/ModalEditWidget/ModalEditWidget';
import WidgetsSelection from 'app/pages/Project/Settings/Dashboards/WidgetsSelection/WidgetsSelection';
import ConfigTree from 'app/pages/Project/Settings/Dashboards/ConfigTree/ConfigTree';
import ModalCreateWidgetGroup from 'app/pages/Project/Settings/Dashboards/ModalCreateWidgetGroup/ModalCreateWidgetGroup';
import ModalEditDashboardLayout from './ModalEditDashboardLayout/ModalEditDashboardLayout';
const DashboardsSettings = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { projectId, dashboardId } = useParams();
    const dashboards = useSelector(dashboardsSelector);
    const selectedDashboard = useSelector(selectedDashboardSelector(dashboardId));
    const widgets = useSelector(widgetsByDashboardSelector(dashboardId));
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield resources.steps.fetchByProject(projectId);
        }))();
    }, []);
    const handleEditDashboard = () => {
        return openModal(_jsx(ModalEditDashboard, { projectId: projectId, dashboard: selectedDashboard }));
    };
    const handleEditDashboardLayout = (dashboardId) => (e) => {
        return openModal(_jsx(ModalEditDashboardLayout, { projectId: projectId, dashboardId: dashboardId }));
    };
    const handleDeleteDashboard = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboardId)
            return;
        return confirmDelete({
            render: `Are you sure you want to delete ${selectedDashboard.name} ?`,
            onValidate: () => __awaiter(void 0, void 0, void 0, function* () {
                yield dispatch(deleteDashboard(dashboardId));
                history.push(`/projects/${projectId}/settings/dashboards`);
            }),
            validateMessage: 'Dashboard deleted',
        });
    });
    const handleCreateWidget = (_a) => __awaiter(void 0, [_a], void 0, function* ({ name, parent, widgetType }) {
        var _b;
        const parentWidget = widgets.find((wid) => wid.id === parent);
        const widget = {
            name,
            parent,
            widgetType,
            config: {},
        };
        dispatch(createWidget({ widget, dashboardId, isSupervisor: (_b = parentWidget === null || parentWidget === void 0 ? void 0 : parentWidget.rel_dashboardWidgetInst.isSupervisor) !== null && _b !== void 0 ? _b : false }));
    });
    const handleEditWidget = (widget) => (e) => {
        e.stopPropagation();
        return openModal(_jsx(ModalEditWidget, { projectId: projectId, widget: widget, allWidgets: widgets }));
    };
    const handleDeleteWidget = (widget) => (e) => {
        e.stopPropagation();
        if (!widget)
            return;
        return confirmDelete({
            render: `Are you sure you want to delete ${widget.name} ?`,
            onValidate: () => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b;
                const updatedDashboard = Object.assign(Object.assign({}, selectedDashboard), { config: Object.assign(Object.assign({}, selectedDashboard.config), { layout: (_b = (_a = selectedDashboard.config) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.filter((widgetLayout) => widgetLayout.i !== widget.id) }) });
                const promises = [dispatch(deleteWidget(widget.id)), dispatch(updateDashboard(updatedDashboard))];
                yield Promise.all(promises);
            }),
            validateMessage: 'Widget deleted',
        });
    };
    const handleAddGroup = (parent) => (e) => {
        e.stopPropagation();
        openModal(_jsx(ModalCreateWidgetGroup, { dashboardId: dashboardId, parent: parent, widgets: widgets }));
    };
    function handleDragEnd(event) {
        const { active, over } = event;
        if (over && active.id !== over.id) {
            handleCreateWidget({
                name: active.data.current.name,
                widgetType: active.data.current.widgetType,
                parent: over.id === 'root' ? null : over.id,
            });
        }
    }
    return (_jsx(DndContext, { onDragEnd: handleDragEnd, children: _jsxs("div", { style: { height: '100%', overflowY: 'auto', padding: '10px', display: 'flex' }, children: [_jsx(WidgetsSelection, {}), _jsx(ConfigTree, { projectId: projectId, dashboardId: dashboardId, dashboards: dashboards, selectedDashboard: selectedDashboard, widgets: widgets, handleDeleteDashboard: handleDeleteDashboard, handleDeleteWidget: handleDeleteWidget, handleEditDashboard: handleEditDashboard, handleEditDashboardLayout: handleEditDashboardLayout, handleEditWidget: handleEditWidget, handleAddGroup: handleAddGroup })] }) }));
};
export default DashboardsSettings;
